import { action } from 'mobx';
import gql from "../utils/gql";
import axios from "axios";
import {Common as util} from "../utils/common";

export class Blog {

  @action getBlogList = (data, cb) => {

    let property = ['store_id', 'shopNo', 'page', 'limit', 'sort', 'searchParams'];
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getBlogList',
      variables: variables,
      getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };

  @action updateBlog = (data, cb) => {

    let params = {
      type: 'mutation',
      operation: 'updateBlog',
      variables: data,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };

  @action removeBlog = (data, cb) => {

    let params = {
      type: 'mutation',
      operation: 'removeBlog',
      variables: data,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
      .then(function (res) {
        if(res.status === 200) {
          if(typeof cb === 'function') {
            cb(res.data.data[params.operation]);
          }
          else {
            return res.data.data[params.operation];
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        return error;
      });
  };
}

export default new Blog();
